import { loadAsyncComponents } from '@akryum/vue-cli-plugin-ssr/client';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import './styles/fonts.css';
import './styles/scss/main.scss';
import './styles/main.scss';
import './styles/_variables.scss';
import './styles/media.scss';
import './styles/_prism.scss';
import './styles/_icons.scss';
import { createApp } from './main';
import { fetchPosts } from './api';
import { generateRoutes } from './heplers';
import Layout from '@/components/Layout';
import VueGtm from 'vue-gtm';
import Vue from 'vue';
import { detect } from 'detect-browser';
import { ONE_WEEK } from './constants/common';
import { StoreActions } from '@/templates/DataNames';

const getCookie = (cookieSource, name) => {
  const cookie = cookieSource.split(';').find((cookie) => cookie.trim().startsWith(`${name}=`));
  if (cookie) return cookie.split('=')[1];
};

const checkCookieAllowed = (name) => {
  const cookie = localStorage.getItem('cookie');
  return cookie && cookie.includes(name);
};

const setCookie = (cookieSource, value) => {
  const cookieString = `with_by_link=${encodeURIComponent(
    String(value)
  )}; Max-Age=${ONE_WEEK}; Path=/; Secure; SameSite=lax`;

  cookieSource.cookie = cookieString;
};

const isOldSafari = (function () {
  const browser = detect();
  return browser.name === 'safari' && parseFloat(browser.version) < 11.3;
})();

createApp({
  async beforeApp({ router, store }) {
    const queryWithByLink = Boolean(
      new URLSearchParams(window.location.search).get('with_by_link')
    );
    const cookieWithByLink = Boolean(getCookie(document.cookie, 'with_by_link'));
    const withByLink = queryWithByLink || cookieWithByLink;

    await fetchPosts('getTree', withByLink ? { with_by_link: withByLink } : null)
      .then((response) => {
        const _routes = response && response.data ? generateRoutes(response.data, Layout) : [];
        router.addRoutes(_routes);

        if (withByLink) {
          if (checkCookieAllowed('functionality_cookies')) {
            setCookie(document, withByLink);
          }
        }
      })
      .catch((error) => error);

    await loadAsyncComponents({ router });

    try {
      Vue.use(VueGtm, {
        id: 'GTM-PDKBNPV',
        enabled: false,
        debug: false,
        loadScript: !process.env.NODE_ENV,
        vueRouter: router,
      });
    } catch (e) {}
  },
  async afterApp({ app, store }) {
    // Handle the case when we navigate by a link with a hash, otherwise it gets removed
    if (window.location.hash && window.__INITIAL_STATE__['route']) {
      window.__INITIAL_STATE__['route'].fullPath += window.location.hash;
    }
    try {
      localStorage.setItem('isOldSafari', isOldSafari);

      // If the language pack saved in localStorage does not match the one from store.state, clear localStorage
      let currentLanguagePack = store.state.selectedLanguagesPack;
      let storedLanguagePack = JSON.parse(localStorage.getItem('selectedLangs'));
      if (
        storedLanguagePack &&
        Object.keys(currentLanguagePack).length !== Object.keys(storedLanguagePack).length
      ) {
        localStorage.removeItem('selectedLangs');
      }
    } catch (e) {}
    store.replaceState(window.__INITIAL_STATE__);
    await store.dispatch(StoreActions.COUNTRY_CODE);
    await store.dispatch(StoreActions.REDIRECTS);

    app.$mount('#app');
  },
}).catch();
